import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import React from "react";
var __jsx = React.createElement;
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import { IconButton, InputAdornment, TextField } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { useDebounce } from 'react-use';
import { StyledSearch } from './SearchBox.style';

var SearchBox = function SearchBox(_ref) {
  var fieldLabelId = _ref.fieldLabelId,
      refine = _ref.refine,
      currentRefinement = _ref.currentRefinement;
  var intl = useIntl();

  var _useState = useState(currentRefinement),
      textInput = _useState[0],
      setTextInput = _useState[1];

  useDebounce( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return refine(textInput);

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), 500, [textInput]);
  return __jsx(TextField, {
    value: textInput,
    onChange: function onChange(event) {
      return setTextInput(event.target.value);
    },
    label: intl.formatMessage({
      id: "".concat(fieldLabelId)
    }),
    variant: "outlined",
    fullWidth: true,
    InputProps: {
      endAdornment: __jsx(InputAdornment, {
        position: "end"
      }, textInput ? __jsx(IconButton, {
        onClick: function onClick() {
          return setTextInput('');
        }
      }, __jsx(Close, null)) : __jsx(StyledSearch, null))
    }
  });
};

export default SearchBox;